import { useState, useRef, useCallback } from 'react';
import { toast } from 'sonner';

export function useXmlFiles(label = 'file') {
  const [files, setFiles] = useState([]);
  const inputRef = useRef(null);

  const handleSelect = useCallback((e) => {
    const selected = Array.from(e.target.files);
    const xmlFiles = selected.filter(f => f.name.toLowerCase().endsWith('.xml'));
    if (xmlFiles.length === 0) { toast.error('Please select XML files'); return; }
    Promise.all(xmlFiles.map(file =>
      new Promise(resolve => {
        const reader = new FileReader();
        reader.onload = (ev) => resolve({ filename: file.name, content: ev.target.result });
        reader.readAsText(file);
      })
    )).then(data => {
      setFiles(prev => [...prev, ...data]);
      toast.success(`Added ${xmlFiles.length} ${label} file(s)`);
    });
  }, [label]);

  const remove = useCallback((index) => {
    setFiles(prev => prev.filter((_, i) => i !== index));
  }, []);

  const clear = useCallback(() => setFiles([]), []);

  return { files, inputRef, handleSelect, remove, clear };
}
